var WidgetPromo = window.WidgetPromo = (function () {

	var WidgetPromo = function (container) {
		this.dom = {
			container: null,
			slides: [],
			linksContainer: null,
			links: []
		}

		this.timer = null;
		this.delay = 5000;
		this.activeIndex = 0;

		this.dom.container = container;
		this.dom.slides = container.find('[js-node="widget-promo-slide"]');
		this.dom.linksContainer = container.find('[js-node="widget-promo-slides-links-container"]');

		if (this.dom.slides.length > 1) {
			this.createLinks();
			this.setActiveSlide(0);
			this.startTimer();
		} else {
			this.dom.slides.eq(0).addClass('m-active');
		}

		this.bindUI();
	};

	WidgetPromo.prototype.dispose = function () {
		this.unbindUI();
	};

	WidgetPromo.prototype.bindUI = function () {
		var self = this;

		self.dom.container.on('click', '[js-node="widget-promo-slide-link"]', function () {
			self.activeIndex = $(this).index();
			self.setActiveSlide(self.activeIndex);
			self.stopTimer();
			self.startTimer();
		});
	};

	WidgetPromo.prototype.unbindUI = function () {
        app.console.log('unbind WidgetPromo');
	};

	WidgetPromo.prototype.createLinks = function () {
		var self = this;

		self.dom.slides.each(function () {
			self.dom.linksContainer.append('<li class="widget-promo__slide-link" js-node="widget-promo-slide-link"></li>')
		});

		self.dom.links = self.dom.container.find('[js-node="widget-promo-slide-link"]');
	};

	WidgetPromo.prototype.setActiveSlide = function (i, animationType) {
		// TODO СЃР»Р°Р№Рґ-Р°РЅРёРјР°С†РёСЏ
		this.dom.slides.removeClass('m-active');
		this.dom.slides.eq(i).addClass('m-active');

		this.dom.links.removeClass('m-active');
		this.dom.links.eq(i).addClass('m-active');
	}

	WidgetPromo.prototype.startTimer = function () {
		var self = this;

		self.timer = setInterval(function () {
			++self.activeIndex;

			if (self.activeIndex == self.dom.slides.length)
				self.activeIndex = 0;

			self.setActiveSlide(self.activeIndex);
		}, self.delay);
	}

	WidgetPromo.prototype.stopTimer = function () {
		clearInterval(this.timer);
	}

	return WidgetPromo;
}());

var widgetsPromo = (function () {
	var data = {
		widgets: []
	};

	return {
		data: data,
		init: function () {
			$('[js-node="widget-promo"]').each(function () {
				var container = $(this);
				data.widgets.push(new WidgetPromo(container));
			});
		},
		dispose: function () {

		}
	}
}());

$(function () {
	widgetsPromo.init();
});